import React from 'react';


export default class Preview extends React.Component {

  componentDidMount() {
    window.sdk.on('renewStream', () => {
     
    })
  }

  render() {
    return (
      <iframe id="preview_iframe" src={ '/live/' + window.programId + '?v4=1' } ></iframe>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/Manager/Preview.js